import React from 'react';
import GridContainer from 'components/UI/Grid/GridContainer';
import GridItem from 'components/UI/Grid/GridItem';
import PaymentDetails from 'components/Payment/Details';
import PropTypes from 'prop-types';

const ScreenPaymentDetails = props => {
  const { match } = props;
  return (
    <GridContainer>
      <GridItem xs={12}>
        <PaymentDetails id={match.params.id} />
      </GridItem>
    </GridContainer>
  );
};

ScreenPaymentDetails.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};
export default ScreenPaymentDetails;
